import { Injectable } from '@angular/core';
import { ApiService } from '../..';

@Injectable()
export class DanhMucTramService {

  constructor(public api: ApiService) { }
  APIURL_Chung = "api/ExcuteOracle"
  //Thêm danh mục
  public themDanhMuc(tenDanhMuc, danhMucCha, loaiDanhMuc, maTaiKhoan, ip,isBlueTooth) {
    var param = {
      "config": '{"namesql":"PKG_DANHMUC.P_THEM_DANHMUC","connstr":"Amiss42"}',
      "para": '{"v_tendanhmuc":"' + tenDanhMuc + '","v_danhmuccha":"' + danhMucCha + '","v_loaidanhmuc":"' + loaiDanhMuc + '","v_mataikhoan":"' + maTaiKhoan + '","v_ip":"' + ip + '","v_hhu_bluetooth":"'+isBlueTooth+'"}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  //Sửa danh mục
  public suaDanhMuc(danhMucID, tenDanhMuc, loaiDanhMuc, maTaiKhoan, ip,isBlueTooth) {
    var param = {
      "config": '{"namesql":"PKG_DANHMUC.P_SUA_TT_DANHMUC","connstr":"Amiss42"}',
      "para": '{"v_danhmucid":"' + danhMucID + '","v_tendanhmuc":"' + tenDanhMuc + '","v_loaidanhmuc":"' + loaiDanhMuc + '","v_mataikhoan":"' + maTaiKhoan + '","v_ip":"' + ip + '","v_hhu_bluetooth":"'+isBlueTooth+'"}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  //Xóa danh mục
  public xoaDanhMuc(danhMucID, maTaiKhoan, ip) {
    var param = {
      "config": '{"namesql":"PKG_DANHMUC.P_XOA_DANHMUC","connstr":"Amiss42"}',
      "para": '{"v_danhmucid":"' + danhMucID + '","v_mataikhoan":"' + maTaiKhoan + '","v_ip":"' + ip + '"}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/quan-ly/danh-muc-tram/danhmuctram.service.ts